// extracted by mini-css-extract-plugin
export default {"image":"BannerAndThumbnailImagesFormControls_image__gaGKS","thumbnailImage":"BannerAndThumbnailImagesFormControls_thumbnailImage__Djjou"};